import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { Observable, OperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WebApiService } from 'src/app/shared';
import { ElectricityMeterUnitEntry } from '../charging-stations-section.model';
import { EmuEntryStore } from '../state/emu-entry.state';


@Injectable({ providedIn: 'root' })
export class EmuEntryService extends WebApiService {
  private emuEntryUrl = 'emuentry';

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar, private store: EmuEntryStore) {
    super(http, snackBar);
  }

  public getEmuEntry(pojectId: Guid): Observable<ElectricityMeterUnitEntry> {
    return this.http
      .get<ElectricityMeterUnitEntry>(`${this.offersUrl}/${pojectId}/${this.emuEntryUrl}`, { responseType: 'json' })
      .pipe(
        this.handleApiRequest(),
        this.setEmuEntryInStore(this.store));
  }

  public add(pojectId: Guid, emuEntry: ElectricityMeterUnitEntry): Observable<ElectricityMeterUnitEntry> {
    return this.http
      .post<ElectricityMeterUnitEntry>(`${this.offersUrl}/${pojectId}/${this.emuEntryUrl}`, emuEntry, { responseType: 'json' })
      .pipe(
        this.handleApiRequest(),
        this.setEmuEntryInStore(this.store));
  }

  public updateOnlyInStore(emuEntry: ElectricityMeterUnitEntry): void {
    this.updateEmuEntyInStore(this.store, emuEntry);
  }

  public update(pojectId: Guid, emuEntry: ElectricityMeterUnitEntry): Observable<ElectricityMeterUnitEntry> {
    return this.http
      .put<ElectricityMeterUnitEntry>(`${this.offersUrl}/${pojectId}/${this.emuEntryUrl}`, emuEntry, { responseType: 'json' })
      .pipe(
        this.handleApiRequest(),
        this.setEmuEntryInStore(this.store));
  }

  public remove(pojectId: Guid): Observable<ElectricityMeterUnitEntry> {
    return this.http
      .delete<ElectricityMeterUnitEntry>(`${this.offersUrl}/${pojectId}/${this.emuEntryUrl}`, { responseType: 'json' })
      .pipe(
        this.handleApiRequest(),
        tap(() => this.store.update(state => state.emuEntry = undefined)));
  }

  private setEmuEntryInStore(store: EmuEntryStore): OperatorFunction<ElectricityMeterUnitEntry, ElectricityMeterUnitEntry> {
    return (source$: Observable<ElectricityMeterUnitEntry>): Observable<ElectricityMeterUnitEntry> => {
      return source$.pipe(
        tap(emuEntry => this.updateEmuEntyInStore(store, emuEntry))
      );
    };
  }

  private updateEmuEntyInStore(store: EmuEntryStore, emuEntry: ElectricityMeterUnitEntry): void {
    store.update(state => {
      if (!!emuEntry) {
        state.emuEntry = { ...emuEntry };
      } else {
        state.emuEntry = undefined;
      }
    });
  }
}
